<!--
 - HTML Order Notifications component
 -
 - @author Jenny Lam <jlam@buildcentrix.com>
 - @copyright (c) 2025 Build Centrix
 -->
<bc-atoms-button
  label="{{'notifications.title'|translate }}"
  title="{{'notifications.description'|translate }}"
  icon="bell"
  display="block"
  size="small"
  [type]="notificationButtonType"
  [badge]="notificationsCount"
  [disabled]="false"
  [iconOnly]="true"
>
  <div dropdown-content class="notifications-container">
    <form class="m-2">
      <bc-atoms-input-group
        labelIcon="bell"
        labelTitle="{{'notifications.title'|translate}}"
        labelDescription="{{'exports.description'|translate}}"
      >
        <div *ngIf="notificationsCount > 0">
          <div
            *ngFor="let notification of wdOrdersService.orderShippingNotifications"
            class="notification-container"
          >
            <a
              class="notification-item dropdown-item"
              href="{{getOrderDetailsUrl(notification.index)}}"
              target="_blank"
            >
              <bc-atoms-icon
                style="color: orange;"
                type="error"
              ></bc-atoms-icon>
              <label
                class="notification-text"
                [innerHTML]="'notifications.message'|translate: { orderNumber:
            notification.number }"
              >
                {{'notifications.message'|translate: { orderNumber:
                notification.number } }}
              </label>
            </a>
          </div>
        </div>
        <div *ngIf="notificationsCount < 1" class="text-center">
          <div class="notification-item dropdown-item">
            <label class="notification-text">
              {{'notifications.noneMessage'|translate }}
            </label>
          </div>
        </div>
      </bc-atoms-input-group>
    </form>
  </div>
</bc-atoms-button>
